// helpers
import {formatCurrency} from '../../../../helpers';

// types
import {TFunction} from 'i18next';
import {SubscriptionDetails} from '../../../../services/ApiService/types';

/**
 * Get the detailed fields for subscription details
 * @param subscriptionDetails
 * @param t
 */
export const getDetailedFields = (
  subscriptionDetails: SubscriptionDetails,
  t: TFunction,
) => {
  return [
    {
      label: t('global_status'),
      content: subscriptionDetails.status,
    },
    {
      label: t('subscription_name'),
      content: subscriptionDetails.subscriptionName,
    },
    {
      label: t('subscription_monthly_price'),
      content: formatCurrency(subscriptionDetails.subscriptionMonthlyPrice),
    },
    {
      label: t('subscription_total_cost'),
      // subscription amount + tax
      content: formatCurrency(
        subscriptionDetails.subscriptionAmount + subscriptionDetails.tax,
      ),
    },
    {
      label: t('subscription_tax'),
      content: formatCurrency(subscriptionDetails.tax),
    },
    {
      label: t('subscription_amount'),
      content: formatCurrency(subscriptionDetails.subscriptionAmount),
    },
    {
      label: t('subscription_cashbackAmount'),
      content: formatCurrency(subscriptionDetails.cashbackAmount),
    },
    {
      label: t('global_paymentFrequency'),
      content: subscriptionDetails.paymentFrequency.toString(),
    },
    {
      label: t('global_numberOfPayments'),
      content: subscriptionDetails.initialNumberOfPayments.toString(),
    },
    {
      label: t('global_totalOwing'),
      content: formatCurrency(subscriptionDetails.totalOwing),
    },
    {
      label: t('subscription_duration'),
      content: subscriptionDetails.duration,
    },
    {
      label: t('global_creationDate'),
      content: subscriptionDetails.creationDate,
    },
    {
      label: t('subscription_endDate'),
      content: subscriptionDetails.subscriptionContentEndDate,
    },
  ];
};
